import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";
import CarDirectorioDetalle from "../element/CarDirectorioDetalle";
import EmptyState from "../element/EmptyState";
// Contexto
import dataContext from "../context/User";
// Datos
import directorioESEN from "../hooks/directorioESEN";
// Helper
import SetBitacora from "../helper/SetBitacora";
import loadMenu from "../js/main";
import Footer from "./Footer";

// Normaliza para buscar sin distinguir mayúsculas ni acentos
const normalizar = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

const Directorio = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  const [filtro, setFiltro] = useState("");

  useEffect(() => {
    if (datos) {
      let cred = JSON.parse(datos);
      dataUser.token = cred.token;
      dataUser.nombre = cred.nombre;
      dataUser.carnet = cred.carnet;

      SetBitacora.set(cred.carnet, "Directorio_ESEN", cred.token);
      loadMenu();
    } else {
      history.push("/");
    }
  }, [datos, history, dataUser]);

  const q = normalizar(filtro);
  const colaboradores = directorioESEN
    .filter(
      (c) =>
        !q ||
        normalizar(c.nombre).indexOf(q) !== -1 ||
        normalizar(c.cargo).indexOf(q) !== -1
    )
    .sort((a, b) => a.nombre.localeCompare(b.nombre, "es"));

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Directorio ESEN</h2>
        <div className="card mb-4">
          <div className="card-body">
            <div className="form-group mb-0">
              <label htmlFor="txtBuscarColabotador">
                <i className="fa fa-search mr-2" aria-hidden="true"></i>
                Buscar colaborador
              </label>
              <input
                type="text"
                className="form-control"
                id="txtBuscarColabotador"
                placeholder="Escribe un nombre o cargo"
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
            </div>
          </div>
        </div>

        {colaboradores.length > 0 ? (
          <div className="row">
            <CarDirectorioDetalle data={colaboradores} />
          </div>
        ) : (
          <EmptyState icon="fa-address-book-o" title="Sin resultados">
            No encontramos colaboradores con ese término. Intenta con otro nombre o cargo.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default Directorio;
